import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectFieldDefinitionInfo } from './ProjectFieldDefinitionInfo.schema';
import { FieldScopeInfo } from './FieldScopeInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectFieldDefinitionInfoWithScopesFragment = { __typename?: 'ProjectFieldDefinition', fieldType: Types.FieldTypeEnum, id: string, isDefaultField?: boolean | null, isFilterable?: boolean | null, isGroupable?: boolean | null, isSortable?: boolean | null, isSystemField: boolean, name: string, scopes?: { __typename?: 'FieldDefinitionScopeConnection', nodes: Array<{ __typename?: 'Account', id: string } | { __typename?: 'Project', id: string, name: string, imageUrl?: string | null, workspaceId: string } | { __typename?: 'Workspace', id: string, name: string, imageUrl?: string | null }> } | null, configuration?: { __typename?: 'DateFieldConfiguration', displayFormat?: Types.DisplayFormatEnum | null, displayTimezone?: boolean | null, includeTime?: boolean | null, timeFormat?: Types.TimeFormatEnum | null } | { __typename?: 'NumberFieldConfiguration', scale?: number | null } | { __typename?: 'RatingFieldConfiguration', color?: string | null, maxValue: number, style?: Types.RatingStyleEnum | null } | { __typename?: 'SelectFieldConfiguration', options: Array<{ __typename?: 'SelectOption', color?: string | null, displayName: string, id: string }> } | { __typename?: 'ToggleFieldConfiguration', color?: string | null } | { __typename?: 'UserFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | { __typename?: 'UsersFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, selectType: Types.MemberSelectTypeEnum, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | null };

export const ProjectFieldDefinitionInfoWithScopes = /*#__PURE__*/ gql`
    fragment ProjectFieldDefinitionInfoWithScopes on ProjectFieldDefinition {
  ...ProjectFieldDefinitionInfo
  scopes(page: {first: 1000}) {
    nodes {
      ...FieldScopeInfo
    }
  }
}
    ${ProjectFieldDefinitionInfo}
${FieldScopeInfo}` as unknown as DocumentNode<ProjectFieldDefinitionInfoWithScopesFragment, unknown>;

        

        
export const useProjectFieldDefinitionInfoWithScopesFragment = (
  input: string | Omit<UseFragmentOptions<ProjectFieldDefinitionInfoWithScopesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'ProjectFieldDefinition' } };
    return input;
  })();

  return useFragment<ProjectFieldDefinitionInfoWithScopesFragment>({
    fragment: ProjectFieldDefinitionInfoWithScopes,
    fragmentName: 'ProjectFieldDefinitionInfoWithScopes',
    ...options,
  });
};
  
        